import { OrbitAttributesType } from "../../../../types/threeJsTypes/controlsTypes";

export const OrbitAttributes: OrbitAttributesType = {
  autoRotate: false,
  autoRotateSpeed: 2,
  enableDamping: false,
  enableZoom: false,
};
